export default {
  DOWNLOAD: 'Descargar',
  PROCESSING: 'Procesando',
  GENERAL_EVENT_INFO: 'Información general del evento',
  EVENT_DETAILS: 'Detalles del evento',
  GENERATE_NEW: 'Generar nuevo',
  REPORT_NOT_GENERATED:
    'Su informe aún no se ha generado o no se ha capturado ningún dato hasta el momento. Por favor, inténtelo de nuevo después de algún tiempo.',
  REPORT_DOWNLOADED: 'Informe Descargado correctamente',
  DOWNLOAD_REPORT: 'Descargar informe',
  LAST_GENERATED: 'Último informe generado el',
  DOWNLOAD_REPORT_INFO: 'Generar un nuevo informe puede tardar un momento, así que mantenga esta pestaña abierta.'
}
